// extracted by mini-css-extract-plugin
var _1 = "DocumentAccessLevelField-moduleAccessLevelField__dM__g";
export { _1 as "AccessLevelField" }
